<template>
  <div>
    <van-nav-bar :title="generateCustomizeString('orderWriteOff')" />
    <div style="width: 100%; padding-bottom: 50px;">
      <van-row>
        <div class="order-head">
          <van-col span="24">{{this.orderDetailData.out_trade_no}}
          </van-col>
          <van-col span="24">
            <span style="text-align: right; color: #ffa800; font-size: 14px;">{{generateCustomizeString(this.orderDetailData.status_name)}}</span>
          </van-col>
        </div>
        <div>
          <van-tabs class="order-tabs" v-model="activeTab" sticky :offset-top=0 :ellipsis=false :line-width=60>
            <van-tab :title="generateCustomizeString('orderDetails')">
              <order-info v-bind:orderDetailData="orderDetailData" v-bind:orderTransaction="orderTransaction" v-bind:wechatDetail="wechatDetail" v-bind:orderFeeDetail="orderFeeDetail" v-bind:orderProductData="orderProductData"></order-info>
            </van-tab>
            <!-- <van-tab :title="generateCustomizeString('goodsList')">
              <goods-list v-bind:orderProductData="orderProductData" v-bind:orderDetailData="orderDetailData"></goods-list>
            </van-tab> -->
          </van-tabs>
          <div style="position: fixed; bottom: 0; width: 100%;" v-if="this.orderDetailData.status === 10">
            <van-button type="primary" size="large" @click="writeOffClick">{{generateCustomizeString('writeOffButton')}}</van-button>
          </div>
        </div>
      </van-row>
    </div>

    <van-dialog
      v-model="writeOffDialog"
      show-cancel-button
      :confirmButtonText="generateCustomizeString('confirm')"
      :cancelButtonText="generateCustomizeString('cancel')"
      :title="generateCustomizeString('writeOffCode')"
      @confirm="writeOffConfirm"
    >
      <!-- <van-field
        v-model="writeOffCode"
        :label="generateCustomizeString('writeOffCode')"
        :placeholder="generateCustomizeString('writeOffCode')"
        maxlength="4"
        style="margin: 20px 0px; padding: 10px 50px;"
      /> -->
      <!-- PasswordInput -->
      <van-password-input
        :value="writeOffCode"
        :length="4"
        :gutter="15"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
        style="margin: 20px 0;"
      />
      <!-- NumberKeyboard -->
      <van-number-keyboard
        :show="showKeyboard"
        @input="onInput"
        @delete="onDelete"
      />
    </van-dialog>
    <van-popup
      v-model="showKeyboardPopup"
      position="bottom"
      :style="{ height: '30%' }"
    >
    </van-popup>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, NavBar, Tabbar, TabbarItem, Tab, Tabs, Button, Cell, CellGroup, Tag, Dialog, Toast, Field, PasswordInput, NumberKeyboard, Popup } from 'vant'
import OrderInfo from './WriteOffOrderInfo'
import GoodsList from './WriteOffGoodsList'
import request from '@/utils/request'
import dayjs from 'dayjs'
import store from '@/store'

export default {
  name: 'WriteOffOrderDetail',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    [Popup.name]: Popup,
    OrderInfo,
    GoodsList
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg',
      orderDetailData: {},
      orderTransaction: [],
      orderProductData: [],
      wechatDetail: {},
      imageList: [],
      imgListKey: [],
      updateStatusDialog: false,
      orderStatus: null,
      imageKeys: [],
      orderFeeDetail: {},
      writeOffDialog: false,
      writeOffCode: '',
      value: '123',
      showKeyboard: true,
      showKeyboardPopup: false
    }
  },
  methods: {
    generateCustomizeString,
    goOperation() {
      this.activeTab = 1
    },
    getOperationStatus(status) {
      var statusName = ''
      switch (status) {
        case 1:
          statusName = this.generateCustomizeString('orderStatus')
          break
        case 2:
          statusName = this.generateCustomizeString('orderValue')
          break
        case 3:
          statusName = this.generateCustomizeString('others')
          break
        default:
          statusName = this.generateCustomizeString('others')
      }
      return statusName
    },
    fetchOrderInfo() {
      request({
        url: 'write-off-order',
        method: 'get',
        params: {
          order_id: this.$route.params.orderId
        }
      })
        .then(response => {
          const orderData = response.data
          const orderTransactionData = response.data.transactions
          var orderFeeDetailData = {}
          if (response.data.is_agent_order === true) {
            orderFeeDetailData = response.data.order_cost_fee_detail
          } else {
            orderFeeDetailData = response.data.order_fee_detail
          }

          this.orderDetailData = orderData
          this.orderTransaction = orderTransactionData
          this.orderFeeDetail = orderFeeDetailData

          this.orderStatus = response.data.status

          if (this.orderDetailData.delivery_at) {
            this.orderDetailData.delivery_at = this.orderDetailData.delivery_at.replace(/-/g, '/')
            this.orderDetailData.delivery_at = dayjs(new Date(this.orderDetailData.delivery_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.orderDetailData.created_at) {
            this.orderDetailData.created_at = this.orderDetailData.created_at.replace(/-/g, '/')
            this.orderDetailData.created_at = dayjs(new Date(this.orderDetailData.created_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.orderDetailData.finished_at) {
            this.orderDetailData.finished_at = this.orderDetailData.finished_at.replace(/-/g, '/')
            this.orderDetailData.finished_at = dayjs(new Date(this.orderDetailData.finished_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.orderDetailData.paid_at) {
            this.orderDetailData.paid_at = this.orderDetailData.paid_at.replace(/-/g, '/')
            this.orderDetailData.paid_at = dayjs(new Date(this.orderDetailData.paid_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
          if (response.data.customer.wechat_auths.length && response.data.customer.wechat_auths[0].user_info) {
            this.wechatDetail = response.data.customer.wechat_auths[0].user_info
          }

          // Order fee details
          if (this.orderFeeDetail) {
            this.orderFeeDetail.total_goods_fee =
              parseFloat((this.orderFeeDetail.total_goods_fee * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_activity_reduction =
              parseFloat((this.orderFeeDetail.total_activity_reduction * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_goods_fee_after_discounted =
              parseFloat((this.orderFeeDetail.total_goods_fee_after_discounted * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_express_fee =
              parseFloat((this.orderFeeDetail.total_express_fee * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_express_fee_after_discounted =
              parseFloat((this.orderFeeDetail.total_express_fee_after_discounted * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_express_fee_reduction =
              parseFloat(this.orderFeeDetail.total_express_fee - this.orderFeeDetail.total_express_fee_after_discounted).toFixed(2)
            this.orderFeeDetail.total_coupon_reduction =
              parseFloat((this.orderFeeDetail.total_coupon_reduction * 100) / 10000).toFixed(2)
            this.orderFeeDetail.total_fee_after_discounted =
              parseFloat((this.orderFeeDetail.total_fee_after_discounted * 100) / 10000).toFixed(2)
            this.orderFeeDetail.profit = parseFloat((response.data.profit * 100) / 10000).toFixed(2)
            this.orderFeeDetail.fee = parseFloat((response.data.fee * 100) / 10000).toFixed(2)
            this.orderFeeDetail.use_activity_list = this.orderFeeDetail.detail_json.use_activity_list
            this.orderFeeDetail.use_coupon_list = this.orderFeeDetail.detail_json.use_coupon_list
          }
          console.log(this.orderFeeDetail)

          // Product Data
          const orderGoods = response.data.order_goods
          const data = orderGoods

          for (let i = 0; i < orderGoods.length; i++) {
            var obj = {}
            if (orderGoods[i].first_image_url) {
              obj.productThumbnailUrl =
                orderGoods[i].first_image_url +
                '?imageView2/0/w/128/h/128/q/75|imageslim'
            }
            obj.productTitle = orderGoods[i].product_full_name
            obj.productId = orderGoods[i].bar_code
            if (orderGoods[i].best_use_before_at !== null) {
              obj.bestBefore = orderGoods[i].best_use_before_at
            } else {
              obj.bestBefore = this.generateCustomizeString('new')
            }
            obj.unitPrice = 'NZD $' + parseFloat(orderGoods[i].order_price / 100).toFixed(2)
            obj.amount = orderGoods[i].quantity
            obj.total =
              'NZD $' +
              parseFloat(orderGoods[i].order_price * orderGoods[i].quantity / 100).toFixed(2)

            data[i] = obj
          }
          this.orderProductData = data
          console.log(this.orderExpressData)

          // images
          const images = response.data.images
          for (let i = 0; i < images.length; i++) {
            this.imageList.push(images[i].image_url + '?imageView2/0/w/500/q/75|imageslim')
            this.imgListKey.push(images[i].qiniu_res_key)
          }

          console.log(this.imageList)
          console.log(this.orderDetailData)

          if (store.getters.token) {
            this.$router.push({
              name: 'OrderDetail',
              params: { orderId: this.orderDetailData.id }
            })
          }
          Toast.clear()
        })
        .catch(error => {
          Toast.clear()
          console.warn(error)
        })
    },
    writeOffClick() {
      this.writeOffDialog = true
    },
    writeOffConfirm() {
      var data = {
        order_id: this.orderDetailData.id,
        code: this.writeOffCode
      }
      request({
        url: '/unauth-write-off',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            Toast.success(this.generateCustomizeString('writeOffSuccessfully'))
            this.fetchOrderInfo()
          } else {
            Toast.fail(this.generateCustomizeString('writeOffFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('writeOffFailed'))
        })
        .finally(() => {
          this.writeOffDialog = false
        })
    },
    onInput(key) {
      this.writeOffCode = (this.writeOffCode + key).slice(0, 6)
    },
    onDelete() {
      this.writeOffCode = this.writeOffCode.slice(0, this.writeOffCode.length - 1)
    },
    showKeyboardClick() {
      this.showKeyboardPopup = true
    }
  },
  created: function() {
    Toast.loading({
      mask: true,
      forbidClick: true,
      message: this.generateCustomizeString('loading')
    })
    this.fetchOrderInfo()
  }
}
</script>

<style lang="less" scoped>
.order-head {
  height: 50px;
  background: #fff;
  padding: 10px;
  line-height: 1.5rem;
}
.order-id {
  height: 30px;
  background: #fff;
  padding: 10px;
  line-height: 1.5rem;
  // z-index: 1;
}
.van-number-keyboard {
  bottom: auto;
  position: initial;
}
.van-dialog {
  height: 400px;
  overflow: auto;
}
</style>
